import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../../graphql/types.generated';
export type UpdateBookingDocumentMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateInput;
}>;

export type UpdateBookingDocumentMutationResult = { __typename?: 'Mutation' } & {
  bookingDocumentUpdate?: GraphQLTypes.Maybe<
    { __typename?: 'UpdatePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateBookingDocumentDocument = gql`
  mutation updateBookingDocument($input: UpdateInput!) {
    bookingDocumentUpdate(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
